import { useState } from "react";

// "Fehler melden": kurzer Report-Kanal fuer die Beta. onSubmit liefert true bei Erfolg
// (Worker erreichbar), false sonst (lokale Vorschau / offline).
export function FeedbackPanel({ onSubmit }: { onSubmit: (message: string) => Promise<boolean> }) {
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState<"idle" | "sent" | "error">("idle");

  async function send() {
    if (!message.trim()) return;
    const ok = await onSubmit(message.trim());
    setStatus(ok ? "sent" : "error");
    if (ok) setMessage("");
  }

  return (
    <section className="feedback-view">
      <div className="panel-heading">
        <span className="eyebrow">Fehler melden</span>
        <h2>Etwas falsch, unklar oder kaputt? Schick einen kurzen Hinweis.</h2>
      </div>
      <textarea
        aria-label="Fehlerbeschreibung"
        className="feedback-textarea"
        onChange={(event) => {
          setMessage(event.target.value);
          setStatus("idle");
        }}
        placeholder="Was ist passiert? Welche Frage / welcher Modus?"
        rows={6}
        value={message}
      />
      <button className="primary-action" disabled={!message.trim()} onClick={send} type="button">
        Absenden
      </button>
      {status === "sent" ? <p className="feedback-status ok">Danke! Dein Hinweis ist angekommen.</p> : null}
      {status === "error" ? (
        <p className="feedback-status err">Konnte nicht senden — in der lokalen Vorschau wird Feedback nicht uebertragen.</p>
      ) : null}
    </section>
  );
}
